import React, { useState } from "react";
import Select from "react-select";
import { ThreeDots } from 'react-loader-spinner';
import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";
import { toast } from 'react-toastify';

const customStyles = {
    control: (provided) => ({
        ...provided,
        backgroundColor: "#000",
        borderColor: "#374151",
        color: "white",
        padding: "0.1rem 0.25rem",
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "white",
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: "#111",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? "#1f2937" : "#111",
        color: "white",
    }),
    placeholder: (provided) => ({
        ...provided,
        color: "white",
    }),
    input: (provided) => ({
        ...provided,
        color: "white",
    }),
};

export default function Support() {
    const [selectedSupportType, setSelectedSupportType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState('');
    const supportType = [
        { value: 'technical', label: 'Technical Issue' },
        { value: 'account', label: 'Account Problem' },
        { value: 'feature', label: 'Feature Request' },
        { value: 'billing', label: 'Billing Question' },
        { value: 'other', label: 'Other' },
    ]

    const handleUpdate = async () => {
        if (!selectedSupportType) {
            toast.error("Please select a support type");
            return;
        }
        if (!messages.trim()) {
            toast.error("Please enter a message");
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post(`${API_ENDPOINTS.SUPPORT}`, {
                issueType: selectedSupportType.value,
                message: messages,
            });
            toast.success(response.data.message || "Request submitted successfully");
            setMessages('');
            setSelectedSupportType(null);
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="bg-black text-white px-6 py-8">
            {loading &&
                <ThreeDots
                    visible={true}
                    height="80"
                    width="80"
                    color="#1976d2"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass="dots-loading additional-class"
                />
            }
            <h1 className="text-3xl font-bold mb-8">Support</h1>

            <div className="bg-[#111] border border-border  rounded p-4 md:p-8">

                <h2 className="text-lg font-bold mb-6">Submit a Request</h2>
                <div className="mb-3">
                    <label className="block mb-2 font-medium">Support Type</label>
                    <Select
                        styles={customStyles}
                        options={supportType}
                        value={selectedSupportType}
                        onChange={option => setSelectedSupportType(option)}
                        placeholder="Select Support Type"
                        classNamePrefix="react-select"
                    />
                </div>

                <div className="mb-8">
                    <label className="block mb-2 font-medium">Message</label>
                    <textarea
                        className="w-full h-32 bg-black border border-border rounded px-4 py-3 text-white placeholder-white"
                        value={messages}
                        onChange={(e) => setMessages(e.target.value)}
                        placeholder="Type your message here..."
                    />
                </div>
                <button
                    className="bg-secondary hover:opacity-75 px-4 py-2 rounded text-white w-full"
                    onClick={handleUpdate}
                    disabled={loading}
                >
                    Submit Request
                </button>
            </div>
        </div>
    );
}